module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ser"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "20%",
      "src": "Images/EAPlogo.jpg",
      "width": "20%"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Early American Places is a collaborative project of the University of Georgia Press, New York University Press, Northern Illinois University Press, and the University of Nebraska Press. The series is supported by the Andrew W. Mellon Foundation. For more information, please visit "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.earlyamericanplaces.org",
      "target": "_blank"
    }
  }, [_vm._v("www.earlyamericanplaces.org")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('br')]), _vm._v(" "), _c('p', [_vm._v("Advisory Board")]), _vm._v(" "), _c('p', [_vm._v("Vincent Brown, "), _c('i', [_vm._v("Duke University")])]), _vm._v(" "), _c('p', [_vm._v("Stephanie M. H. Camp, "), _c('i', [_vm._v("University of Washington")])]), _vm._v(" "), _c('p', [_vm._v("Andrew Cayton, "), _c('i', [_vm._v("Miami University")])]), _vm._v(" "), _c('p', [_vm._v("Cornelia Hughes Dayton, "), _c('i', [_vm._v("University of Connecticut")])]), _vm._v(" "), _c('p', [_vm._v("Nicole Eustace, "), _c('i', [_vm._v("New York University")])]), _vm._v(" "), _c('p', [_vm._v("Amy S. Greenberg, "), _c('i', [_vm._v("Pennsylvania State University")])]), _vm._v(" "), _c('p', [_vm._v("Ramón A. Gutiérrez, "), _c('i', [_vm._v("University of Chicago")])]), _vm._v(" "), _c('p', [_vm._v("Peter Charles Hoffer, "), _c('i', [_vm._v("University of Georgia")])]), _vm._v(" "), _c('p', [_vm._v("Karen Ordahl Kupperman, "), _c('i', [_vm._v("New York University")])]), _vm._v(" "), _c('p', [_vm._v("Joshua Piker, "), _c('i', [_vm._v("College of William & Mary")])]), _vm._v(" "), _c('p', [_vm._v("Mark M. Smith, "), _c('i', [_vm._v("University of South Carolina")])]), _vm._v(" "), _c('p', [_vm._v("Rosemarie Zagarri, "), _c('i', [_vm._v("George Mason University")])]), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "piii"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pv"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dee1163e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Hardesty-0002.vue
// module id = 57
// module chunks = 0